export default __webpack_public_path__ + "static/media/05.1a3eaa47.jpg";